import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted } from 'vue';

import { faTimes, faAngleLeft } from '@fortawesome/free-solid-svg-icons';

import { useConstantStore } from '@/stores/pinia/useConstantStore';
import { afterNextPaint } from '@/helpers/async-helper';


export default /*#__PURE__*/_defineComponent({
  __name: 'NewDesignModal',
  props: {
    title: { default: '' },
    closable: { type: Boolean, default: true },
    hasBack: { type: Boolean },
    hasHeader: { type: Boolean, default: true },
    showDefaultTitle: { type: Boolean, default: true },
    hasLargeToolbar: { type: Boolean, default: true },
    onWillDismiss: { type: Function, default: () => Promise.resolve() }
  },
  emits: ['back', 'closed', 'dismiss'],
  setup(__props: any, { emit }) {

const props = __props as { title: string, closable: boolean, hasBack?: boolean, hasHeader: boolean, showDefaultTitle: boolean, hasLargeToolbar: boolean, onWillDismiss: () => Promise<void> };





const ASSETS_DIRECTORY = `/${ASSETS_DIR}`;

const { providers } = useConstantStore();

onMounted(async () => {
	await props?.onWillDismiss();
	emit('closed');
});

const descriptionProviderList = computed(() => {
	return providers()
		.slice(0, 3)
		.map(({ clearName }: any) => ` ${clearName}`);
});

async function handleDismiss() {
	// IPN case: trailer modal is one of the heaviest UI pieces we have.
	// that's why we split the click and the heavy 'dismiss' into two tasks
	await afterNextPaint();

	emit('dismiss');
}

return { __sfc: true,props, emit, ASSETS_DIRECTORY, providers, descriptionProviderList, handleDismiss, faTimes, faAngleLeft }
}

})